import {Rank} from '/constant/TestIDs';
import {
  INTEGRATED_EXECUTIVE_DIRECTOR,
  INTEGRATED_GLOBAL_DIRECTOR,
  INTEGRATED_NATIONAL_DIRECTOR,
  INTEGRATED_PRESIDENTIAL_DIRECTOR,
  INTEGRATED_REGIONAL_DIRECTOR,
} from '/enum/rank.enum';
import {withTranslation} from '/provider/TranslationProvider';

import DetailListItem from '../../DetailListItem';

const tt = (key: any, value: any) =>
  withTranslation.tt(`rankProgressCard.executiveDirectorTeams.${key}`, value);

export default {
  dataComponent: DetailListItem,
  dataComponentProps: {
    getTitle: ({certified}: any) => {
      return certified
        ? tt('title.incomplete.singular', 'Certified')
        : tt('title.incomplete.plural', 'Not Certified');
    },
  },
  extendedDataComponent: undefined,
  extendedDataComponentProps: {},
  isComplete: ({certified}: any) => certified,
  hasExtendedDetail: false,
  presentedFor: [
    INTEGRATED_REGIONAL_DIRECTOR,
    INTEGRATED_NATIONAL_DIRECTOR,
    INTEGRATED_GLOBAL_DIRECTOR,
    INTEGRATED_PRESIDENTIAL_DIRECTOR,
    INTEGRATED_EXECUTIVE_DIRECTOR,
  ],
  testID: Rank.rankCertified,
};
